export class FixedQueue<T> {
  private queue: T[] = [];
  constructor(private maxSize: number) {}

  push(item: T) {
    this.queue.push(item);
    if (this.queue.length > this.maxSize) {
      this.queue.shift();
    }
  }

  toArray(): T[] {
    return [...this.queue];
  }
}
